import { useState, useCallback, useEffect, useMemo } from 'react';

export const useVehicleData = (vehicleMakers, vehicleModelsData) => {
  const [vehicleData, setVehicleData] = useState({
    state: '',
    city: '',
    pincode: '',
    vehicleCategory: '2 Wheeler',
    vehicleType: '',
    vehicleMaker: '',
    vehicleModel: '',
    yearOfPurchase: '',
  });

  const [filteredModels, setFilteredModels] = useState([]);

  const updateVehicleData = useCallback((updates) => {
    setVehicleData((prev) => ({
      ...prev,
      ...updates,
      // Reset dependent fields when category changes
      ...(updates.vehicleCategory && {
        vehicleType: '',
        vehicleMaker: '',
        vehicleModel: '',
        pincode: '',
        state: '',
        city: '',
        yearOfPurchase: '',
      }),
    }));
  }, []);

  // Get filtered vehicle makers based on category
  const filteredVehicleMakers = useMemo(() => {
    if (!vehicleData.vehicleCategory) return [];

    const cmsCategoryName = vehicleData.vehicleCategory;
    const category = vehicleMakers.find((item) => item.displayName === cmsCategoryName);

    return category?.fields?.VehicleMaker || [];
  }, [vehicleData.vehicleCategory, vehicleMakers]);

  // Update filtered models when vehicle type or maker changes
  useEffect(() => {
    const { vehicleType, vehicleMaker } = vehicleData;

    if (!vehicleType || !vehicleMaker) {
      setFilteredModels([]);
      return;
    }

    const typeBlock = vehicleModelsData.find((item) => item.displayName === vehicleType);

    if (!typeBlock?.fields?.Vehicles) {
      setFilteredModels([]);
      return;
    }

    const models = typeBlock.fields.Vehicles.filter(
      (v) => v.fields?.VehicleMaker?.value === vehicleMaker
    ).sort((a, b) =>
      a.fields?.VehicleModel?.value
        ?.toLowerCase()
        .localeCompare(b.fields?.VehicleModel?.value?.toLowerCase())
    );

    setFilteredModels(models);
    setVehicleData((prev) => ({ ...prev, vehicleModel: '' }));
  }, [vehicleData.vehicleType, vehicleData.vehicleMaker, vehicleModelsData]);

  return {
    vehicleData,
    updateVehicleData,
    filteredModels,
    filteredVehicleMakers,
  };
};
